<template>
  <div>
    <!-- Acknowledge Modal -->
    <Modal :title="form.acknowledgement_required && !form.acknowledgement_received ? 'Acknowledge Alert' : 'Add Note'" :open.sync="showAcknowledgeModal">
      <form @submit.prevent="acknowledgeAlert" class="px-6 pb-6">
        <fieldset class="form-group">
          <label for="acknowledgement_note" class="form-label">
            Note
          </label>
          <textarea class="w-full form-textarea" name="acknowledgement_note" id="acknowledgement_note" cols="30" rows="3" v-model="form.acknowledgement_note"></textarea>
        </fieldset>
        <div class="text-right">
          <button class="btn btn-primary" v-submitting="submitting">
            {{ form.acknowledgement_required && !form.acknowledgement_received ? 'Acknowledge Alert' : 'Add Note' }}
          </button>
        </div>
      </form>
    </Modal>

    <!-- Alerts -->
    <div class="h-screen col-span-1 overflow-y-auto bg-gray-100 border-l">
      <div class="sticky top-0 z-50 flex items-center justify-between h-12 px-4 text-sm font-bold tracking-wider text-gray-500 uppercase bg-white shadow-md">
        Alerts 
        <div>
          <Loading v-if="loading" />
        </div>
      </div>
      <div class="p-4 space-y-4">
        <div v-if="alerts.length === 0" class="py-12 text-center text-gray-500">
          No recent alerts.
        </div>
        <div v-for="alert in alerts" :key="alert.id" class="p-5 bg-white border-0 rounded-lg shadow-md">
          <div class="relative flex justify-between text-xs leading-none text-gray-500 rounded-t-lg">
            <div>
              {{ alert.created_at | moment('HH:mm:ss') }}
            </div>
            <button v-tooltip="`Locate Vehicle`" class="absolute top-0 right-0 p-2 transform translate-x-2 -translate-y-2 rounded hover:bg-gray-100" @click="locateVehicle(alert)">
              <fa :icon="['far', 'location']" />
            </button>
          </div>
          <div class="mt-2">
            <div class="flex items-center font-bold">
              {{ automationTypes[alert.type].name }}
            </div>
            <div class="mt-1 text-sm text-gray-500">
              {{ alert.message }}
            </div>
          </div>
          <div class="flex mt-3 text-center rounded-b-lg">
            <div v-if="!alert.acknowledgement_received && alert.acknowledgement_required">
              <button class="text-sm btn btn-primary btn-sm" :class="{ 'btn-secondary': alert.acknowledgement_received }" @click="openAcknowledge(alert)">
                Acknowledge
              </button>
            </div>
            <div v-else-if="!alert.acknowledgement_note">
              <button class="text-sm btn btn-secondary btn-sm" :class="{ 'btn-secondary': alert.acknowledgement_received }" @click="openAcknowledge(alert)">
                Add Note
              </button>
            </div>
            <div class="flex justify-between w-full" v-else>
              <button class="text-sm btn btn-secondary btn-sm" :class="{ 'btn-secondary': alert.acknowledgement_received }" @click="openAcknowledge(alert)">
                Edit Note
              </button>
              <div class="flex items-center flex-none text-xs font-medium tracking-wide text-right uppercase text-emerald-500">
                &check; Acknowledged
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Howl } from 'howler'

export default {
  name: 'MonitorFeed',

  created () {
    this.getLogs()
    this.poll = setInterval(() => { 
      this.getLogs()
    }, 15000)
  },

  beforeDestroy () {
    clearInterval(this.poll)
  },

  computed: {
    ...mapState(['automationTypes'])
  },

  data () {
    return {
      showAcknowledgeModal: false,
      loading: false,
      submitting: false,
      poll: '',
      alerts: [],
      form: {},
      tone: new Howl({ 
        src: ['/sounds/tone.mp3'],
        autoplay: false,
        loop: false
      })
    }
  },

  methods: {
    openAcknowledge (alert) {
      this.form = alert
      this.showAcknowledgeModal = true
      setTimeout(() => {
        document.getElementById('acknowledgement_note').focus()
      }, 10)
    },

    async acknowledgeAlert () {
      try {
        this.submitting = true
        let url = `account/${this.$route.params.account}/automation-logs/${this.form.id}`
        this.form.acknowledgement_received = true
        await this.$api.patch(url, this.form)
        this.form = {}
        this.showAcknowledgeModal = false
      } catch (error) {
        console.error(error)
      } finally {
        this.submitting = false
      }
    },

    async getLogs () {
      try {
        this.loading = true
        const { data } = await this.$api.get(`account/${this.$route.params.account}/monitor/feed`)
        this.alerts = data.logs ? data.logs.data : []
      } catch (error) {
        this.$toasted.error('There was a problem updating the feed. If you see this message again, try refreshing the page.')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    locateVehicle (alert) {
      this.$store.dispatch('publishEvent', { name: 'locateVehicle', data: alert.vehicle })
    }
  },

  watch: {
    alerts (newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        this.tone.play()
      } else if (newVal.length === oldVal.length) {
        if (newVal[0].id !== oldVal[0].id) {
          this.tone.play()
        }
      }
    }
  }
}
</script>